import { DInterfacePreguntasFormulario } from '@dian-cmp/formulario';

export class DPreguntasFormulario implements DInterfacePreguntasFormulario {
    
    public MOSTRAR_PREGUNTAS:boolean = false;
    public PREGUNTAS_FORMULARIO:Array<any> = [
        {
            titulo: '¿Es usted ....?',
            descripcion: 'Pregunta 1 de 2',
            multipleRespuesta: false,
            obligatoria: true,
            esFecha: false,
            enviarRespuestaA: {
                seccion: 'cuerpo',
                casilla: ''
            },
            respuestas: [
                {opcion: 'Si', valor: '1'},
                {opcion: 'No', valor: '0'}
            ]
        }
    ];

}


// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/configuracion/dpreguntas-formulario.ts